import React from "react";
import VaporIconBase from "../VaporIconBase";
import { VaporIconFullProps } from "../VaporIconBase";
import { faCheckCircle } from "@fortawesome/pro-regular-svg-icons/faCheckCircle";
import { faCheckCircle as faCheckCircleSolid } from "@fortawesome/pro-solid-svg-icons/faCheckCircle";
import { IconColor } from "../VaporIcon";

interface CheckCircleIconType extends Omit<VaporIconFullProps, "color"> {
  /**
   * Color of icon
   * @default primary
   */
  color?: IconColor;
}

export const CheckCircle = (props: CheckCircleIconType) => {
  const { color = "primary", iconWeight = "regular", ...other } = props;
  return iconWeight === "regular" ? (
    <VaporIconBase
      color={color}
      {...other}
      icon={faCheckCircle}
    ></VaporIconBase>
  ) : (
    <VaporIconBase
      color="success"
      {...other}
      icon={faCheckCircleSolid}
    ></VaporIconBase>
  );
};
